snt-treeview {
  display: block;

  .category-label {
    display: block;

    .iconCaret {
      padding-left: 3px;
      font-size: 10px;
    }

    .iconCaret.expanded {
      transform: rotate(-180deg);
      padding-right: 3px;
      padding-left: 0px;
    }
  }

  .category-label-row {
    display: inline-flex;
    align-items: center;
  }

  .category-text {
    display: inline-flex;
    justify-items: center;
    justify-content: space-between;
    flex-direction: column;

    &:after {
      content: attr(data-text);
      height: 0;
      visibility: hidden;
      overflow: hidden;
      user-select: none;
      pointer-events: none;
      font-weight: normal;
      font-family: "Averta-Regular";

      @media speech {
        display: none;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }
  li, a {
    &:focus {
      outline: none;
    }

    color: $color-black;
    font-size: 1rem;
    line-height: 1.3125rem;
    text-decoration: none;
  }
  li:hover {
    cursor: pointer;

    > .category-label {
      font-weight: 500;
      font-family: 'Averta-ExtraBold', sans-serif;
      color: $color-primary-accent;
    }

    .iconCaret {
      font-weight: 700;
    }
  }

  li {
    margin-bottom: 1.25rem;
    &:last-child {
      margin-bottom: 0;
    }
    &.active {
      > span {
        border-bottom: 3px solid $color-primary-accent;
        color: $color-primary-accent;
      }
    }
    > ul {
      padding: 1rem 0 0.625rem 1.875rem;
      li {
        margin-bottom: 1rem;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    > a:hover {
      font-weight: 500;
      font-family: 'Averta-ExtraBold', sans-serif;
      color: $color-primary-accent;
      text-decoration: none;
    }

    &:focus.focused {
      .category-label > span {
        font-weight: 500;
        font-family: 'Averta-ExtraBold', sans-serif;
        color: $color-primary-accent;
        outline: 1px solid $color-primary-accent;
        outline-offset: 3px;
      }
    }

    &.selected {
      .category-label > span {
        border-bottom: 2px solid $color-primary-accent;
        padding-bottom: 2px;
        margin-bottom: -4px;
      }
    }
    > span {
      pointer-events: none;
    }
  }

  li {
    a:focus {
      &.focused {
        > span {
          font-weight: 500;
          font-family: 'Averta-ExtraBold', sans-serif;
          color: $color-primary-accent;
          outline: 1px solid $color-primary-accent;
          outline-offset: 3px;
        }
      }
    }
  }
  a {
    display: block;

    &.selected{
      > span {
        border-bottom: 2px solid $color-primary-accent;
        padding-bottom: 2px;
        margin-bottom: -4px;
      }
    }
    &.active {
      border-bottom: 2px solid $color-primary-accent;
      color: $color-primary-accent;
    }
  }
  [role=treeitem] {
    &[aria-expanded=false] {
      > ul {
        display: none;
      }
    }
  }

  @media (min-width: map-get($grid-breakpoints, lg)) {
    .category-label {
      .iconCaret {
        font-size: 12px;
      }
    }
  }
}